var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('div',{staticClass:"s-layout__index_header"},[_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push({ name: 'suppliers-index' })}}},[_vm._v(" Fournisseurs ")])])]),_c('br'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }